import { createContext } from 'react'

import { MemberFormContextType, OrganisationMember } from './types'

export const FormContext = createContext<MemberFormContextType>(null)

export const initMemberForm: OrganisationMember = {
	details: {
		id: '',
		reference_id: '',
		type: '',
		name: '',
		organisation: '',
		startDate: '',
		status: 'ACTIVE',
	},
	contact: {
		phoneNumber: '',
		email: '',
		badge: '',
	},
	notes: {
		content: '',
	},
}
